import { createContext, useContext } from 'react';

const MinimumTextInputContext = /*#__PURE__*/createContext(0);
function useMinimumTextInputLength() {
  return useContext(MinimumTextInputContext);
}

export { MinimumTextInputContext, useMinimumTextInputLength };
//# sourceMappingURL=context.js.map
